import { ConnectorType, defineConnector } from '#layers/data-model/types/data-connectors/define';

export default defineConnector({
	id: 'sqlite',
	name: '$t:connectors.sqlite.name',
	description: '$t:connectors.sqlite.description',
	type: ConnectorType.Relational,

	icon: 'simple-icons:sqlite',
	iconColor: '#0F80CC',
});
